// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CondimentUI_view__7j41E {
  height: 100%;
}

.CondimentUI_loader__waMXb {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
}

.CondimentUI_description__XZvlG {
  width: 200px;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.CondimentUI_input__dyBNz {
  background-color: #fbfbfb;
  border-color: #d2d2d2;
  border-radius: 4px;
  width: 300px;
}

.CondimentUI_menu__SNcgL {
  cursor: pointer;
}

.CondimentUI_layout__8WSMA {
  display: flex;
  gap: 2rem;
  height: calc(100% - 4rem);
  overflow: hidden;
}

.CondimentUI_groups__XMEUe {
  width: 22.5rem;
  min-width: 20rem;
  border-right: 1px solid #e8e8e8;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 0.5rem;
}

.CondimentUI_condiments__yfp1m {
  flex: 1 1;
  overflow: auto;
  padding: 2rem;
  background-color: #fff;
  border-radius: 0.5rem;
}

.CondimentUI_dragger__8PP5K {
  cursor: grab;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.125rem;
  color: #8c8c8c;
  transition: color 0.2s, transform 0.2s;
}

.CondimentUI_dragger__8PP5K:hover {
  color: #1890ff;
  transform: scale(1.2);
}

.CondimentUI_dragger__8PP5K:active {
  cursor: grabbing;
  color: #096dd9;
}

/* Row states during dragging */

.CondimentUI_rowDragging__PvQrQ {
  opacity: 0.4;
  background-color: #fafafa !important;
}

.CondimentUI_rowDragOver__xb-6y {
  background-color: #e6f7ff !important;
  box-shadow: inset 0 2px 0 #1890ff, inset 0 -2px 0 #1890ff;
  transition: background-color 0.15s ease, box-shadow 0.15s ease;
}`, "",{"version":3,"sources":["webpack://./src/pages/condiment/styles/CondimentUI.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AAEd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,+BAA+B;;AAC/B;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yDAAyD;EACzD,8DAA8D;AAChE","sourcesContent":[".view {\n  height: 100%;\n\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n}\n\n.description {\n  width: 200px;\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.input {\n  background-color: #fbfbfb;\n  border-color: #d2d2d2;\n  border-radius: 4px;\n  width: 300px;\n}\n\n.menu {\n  cursor: pointer;\n}\n\n.layout {\n  display: flex;\n  gap: 2rem;\n  height: calc(100% - 4rem);\n  overflow: hidden;\n}\n\n.groups {\n  width: 22.5rem;\n  min-width: 20rem;\n  border-right: 1px solid #e8e8e8;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border-radius: 0.5rem;\n}\n\n.condiments {\n  flex: 1;\n  overflow: auto;\n  padding: 2rem;\n  background-color: #fff;\n  border-radius: 0.5rem;\n}\n\n.dragger {\n  cursor: grab;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.125rem;\n  color: #8c8c8c;\n  transition: color 0.2s, transform 0.2s;\n}\n\n.dragger:hover {\n  color: #1890ff;\n  transform: scale(1.2);\n}\n\n.dragger:active {\n  cursor: grabbing;\n  color: #096dd9;\n}\n\n/* Row states during dragging */\n.rowDragging {\n  opacity: 0.4;\n  background-color: #fafafa !important;\n}\n\n.rowDragOver {\n  background-color: #e6f7ff !important;\n  box-shadow: inset 0 2px 0 #1890ff, inset 0 -2px 0 #1890ff;\n  transition: background-color 0.15s ease, box-shadow 0.15s ease;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view": `CondimentUI_view__7j41E`,
	"loader": `CondimentUI_loader__waMXb`,
	"description": `CondimentUI_description__XZvlG`,
	"input": `CondimentUI_input__dyBNz`,
	"menu": `CondimentUI_menu__SNcgL`,
	"layout": `CondimentUI_layout__8WSMA`,
	"groups": `CondimentUI_groups__XMEUe`,
	"condiments": `CondimentUI_condiments__yfp1m`,
	"dragger": `CondimentUI_dragger__8PP5K`,
	"rowDragging": `CondimentUI_rowDragging__PvQrQ`,
	"rowDragOver": `CondimentUI_rowDragOver__xb-6y`
};
export default ___CSS_LOADER_EXPORT___;
